import type { EventInput, Trip } from "./types";

export class ApiError extends Error {
  constructor(message: string, public status: number, public data?: unknown) { super(message); }
}

export function csrfToken() {
  return document.cookie.split("; ").find((item) => item.startsWith("rv_csrf="))?.split("=")[1] ?? "";
}

export async function api<T>(url: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(url, {
    ...options,
    headers: { "Content-Type": "application/json", ...(options.method && options.method !== "GET" ? { "x-csrf-token": csrfToken() } : {}), ...options.headers }
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new ApiError((data as { error?: string }).error ?? "No fue posible completar la acción", response.status, data);
  return data as T;
}

export const getTrip = (publicId: string) => api<Trip>(`/api/trips/${publicId}`);
export const sendTripEvent = (publicId: string, input: EventInput) => api<Trip & { duplicate: boolean }>(`/api/trips/${publicId}/events`, { method: "POST", body: JSON.stringify(input) });

export function clientEventId() {
  return crypto.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
